var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "primary__Property 1=Primary",
    className: "primary__Property primary__1=Primary"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary__primary-shape",
    fill: "#0132A2",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm.7 9.8a.7.7 0 1 1-1.4 0V7.3a.7.7 0 1 1 1.4 0v3.5ZM7.3 5.2a.7.7 0 1 0 1.4 0 .7.7 0 0 0-1.4 0Z",
    className: "primary__primary-shape",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryInfo);
export default __webpack_public_path__ + "static/media/primary-info.42ed7bd35fb3356d24e435e44880854d.svg";
export { ForwardRef as ReactComponent };